import { Box } from "@mantine/core";

export const CompanyLogo = ({ sx = {}, white = false }) => {
  return (
    <Box sx={sx}>
      <img
        src={white ? "/img/ci/company-logo.png" : "/img/ci/company-logo.png"}
        alt="logo"
        style={{ maxWidth: "300px", maxHeight: "100%", height: "100%", objectFit: "contain" }}
      />
    </Box>
  );
};
